import React from 'react'
import { Tabs, Tab } from '../../Tabs/index'
import { H5 } from '../../Heading/index'
import AddPlaylistOutline from '../../Icon/icons/AddPlaylistOutline/index'
import AirplayOutline from '../../Icon/icons/AirplayOutline/index'
import All from '../../Icon/icons/All/index'
import AltHealing from '../../Icon/icons/AltHealing/index'
import Android from '../../Icon/icons/Android/index'
import ArchetypeAlchemist from '../../Icon/icons/ArchetypeAlchemist/index'
import ArchetypeExplorer from '../../Icon/icons/ArchetypeExplorer/index'
import ArchetypeGuardian from '../../Icon/icons/ArchetypeGuardian/index'
import ArchetypeHealer from '../../Icon/icons/ArchetypeHealer/index'
import ArchetypeMystic from '../../Icon/icons/ArchetypeMystic/index'
import ArchetypeObserver from '../../Icon/icons/ArchetypeObserver/index'
import ArchetypeRebel from '../../Icon/icons/ArchetypeRebel/index'
import ArchetypeSeeker from '../../Icon/icons/ArchetypeSeeker/index'
import ArchetypeVisionary from '../../Icon/icons/ArchetypeVisionary/index'
import Archive from '../../Icon/icons/Archive/index'
import ArrowBottomRight from '../../Icon/icons/ArrowBottomRight/index'
import ArrowDown from '../../Icon/icons/ArrowDown/index'
import ArrowLeft from '../../Icon/icons/ArrowLeft/index'
import ArrowRight from '../../Icon/icons/ArrowRight/index'
import ArrowTopRight from '../../Icon/icons/ArrowTopRight/index'
import ArrowUp from '../../Icon/icons/ArrowUp/index'
import Bell from '../../Icon/icons/Bell/index'
import BellCancel from '../../Icon/icons/BellCancel/index'
import BellOff from '../../Icon/icons/BellOff/index'
import BellSolid from '../../Icon/icons/BellSolid/index'
import Book from '../../Icon/icons/Book/index'
import Bookmark from '../../Icon/icons/Bookmark/index'
import Calendar from '../../Icon/icons/Calendar/index'
import Camera from '../../Icon/icons/Camera/index'
import CaretDown from '../../Icon/icons/CaretDown/index'
import CaretDownOutline from '../../Icon/icons/CaretDownOutline/index'
import CaretLeft from '../../Icon/icons/CaretLeft/index'
import CaretLeftOutline from '../../Icon/icons/CaretLeftOutline/index'
import CaretRight from '../../Icon/icons/CaretRight/index'
import CaretRightOutline from '../../Icon/icons/CaretRightOutline/index'
import CaretUp from '../../Icon/icons/CaretUp/index'
import CaretUpOutline from '../../Icon/icons/CaretUpOutline/index'
import Cart from '../../Icon/icons/Cart/index'
import CastOutline from '../../Icon/icons/CastOutline/index'
import Certificate from '../../Icon/icons/Certificate/index'
import Chart from '../../Icon/icons/Chart/index'
import ChatNew from '../../Icon/icons/ChatNew/index'
import Check from '../../Icon/icons/Check/index'
import CheckSquared from '../../Icon/icons/CheckSquared/index'
import ChevronDown from '../../Icon/icons/ChevronDown/index'
import CircularAdd from '../../Icon/icons/CircularAdd/index'
import ChevronLeft from '../../Icon/icons/ChevronLeft/index'
import ChevronRight from '../../Icon/icons/ChevronRight/index'
import ChevronUp from '../../Icon/icons/ChevronUp/index'
import Clock from '../../Icon/icons/Clock/index'
import ClockSolid from '../../Icon/icons/ClockSolid/index'
import Close from '../../Icon/icons/Close/index'
import ClosedCaptions from '../../Icon/icons/ClosedCaptions/index'
import Comment from '../../Icon/icons/Comment/index'
import CommentAdd from '../../Icon/icons/CommentAdd/index'
import CommentSolid from '../../Icon/icons/CommentSolid/index'
import ControlsOutline from '../../Icon/icons/ControlsOutline/index'
import ConvoNew from '../../Icon/icons/ConvoNew/index'
import Copy from '../../Icon/icons/Copy/index'
import Courses from '../../Icon/icons/Courses/index'
import CrystalBall from '../../Icon/icons/CrystalBall/index'
import Crystals from '../../Icon/icons/Crystals/index'
import Dashboard from '../../Icon/icons/Dashboard/index'
import Delete from '../../Icon/icons/Delete/index'
import Discord from '../../Icon/icons/Discord/index'
import Document from '../../Icon/icons/Document/index'
import DocumentNew from '../../Icon/icons/DocumentNew/index'
import Dot from '../../Icon/icons/Dot/index'
import Download from '../../Icon/icons/Download/index'
import Edit from '../../Icon/icons/Edit/index'
import EllipsisHorizontal from '../../Icon/icons/EllipsisHorizontal/index'
import EllipsisVertical from '../../Icon/icons/EllipsisVertical/index'
import Email from '../../Icon/icons/Email/index'
import EventsPlus from '../../Icon/icons/EventsPlus/index'
import Eye from '../../Icon/icons/Eye/index'
import EyeHide from '../../Icon/icons/EyeHide/index'
import EyeHideSolid from '../../Icon/icons/EyeHideSolid/index'
import EyeOfHorus from '../../Icon/icons/EyeOfHorus/index'
import EyeShow from '../../Icon/icons/EyeShow/index'
import EyeShowSolid from '../../Icon/icons/EyeShowSolid/index'
import FastForward from '../../Icon/icons/FastForward/index'
import FastForward10 from '../../Icon/icons/FastForward10/index'
import File from '../../Icon/icons/File/index'
import FilePdf from '../../Icon/icons/FilePdf/index'
import Film from '../../Icon/icons/Film/index'
import Filter from '../../Icon/icons/Filter/index'
import FilterOff from '../../Icon/icons/FilterOff/index'
import Fire from '../../Icon/icons/Fire/index'
import Flag from '../../Icon/icons/Flag/index'
import Fullscreen from '../../Icon/icons/Fullscreen/index'
import FullscreenOff from '../../Icon/icons/FullscreenOff/index'
import FullscreenOn from '../../Icon/icons/FullscreenOn/index'
import GearOutline from '../../Icon/icons/GearOutline/index'
import GearSolid from '../../Icon/icons/GearSolid/index'
import Gift from '../../Icon/icons/Gift/index'
import Globe from '../../Icon/icons/Globe/index'
import GlobeArrow from '../../Icon/icons/GlobeArrow/index'
import Google from '../../Icon/icons/Google/index'
import Graph from '../../Icon/icons/Graph/index'
import Hamsa from '../../Icon/icons/Hamsa/index'
import HeadphonesOutline from '../../Icon/icons/HeadphonesOutline/index'
import Heart from '../../Icon/icons/Heart/index'
import HeartFill from '../../Icon/icons/HeartFill/index'
import HeartOff from '../../Icon/icons/HeartOff/index'
import History from '../../Icon/icons/History/index'
import Home from '../../Icon/icons/Home/index'
import IOS from '../../Icon/icons/IOS/index'
import InfoCircled from '../../Icon/icons/InfoCircled/index'
import InspiringDocs from '../../Icon/icons/InspiringDocs/index'
import Instagram from '../../Icon/icons/Instagram/index'
import Laptop from '../../Icon/icons/Laptop/index'
import LearnerLevelAdvanced from '../../Icon/icons/LearnerLevelAdvanced/index'
import LearnerLevelBeginner from '../../Icon/icons/LearnerLevelBeginner/index'
import LearnerLevelIntermediate from '../../Icon/icons/LearnerLevelIntermediate/index'
import LightHouse from '../../Icon/icons/LightHouse/index'
import Link from '../../Icon/icons/Link/index'
import LinkedIn from '../../Icon/icons/LinkedIn/index'
import Location from '../../Icon/icons/Location/index'
import Locked from '../../Icon/icons/Locked/index'
import Login from '../../Icon/icons/Login/index'
import LogoArchitect from '../../Icon/icons/LogoArchitect/index'
import LogoSage from '../../Icon/icons/LogoSage/index'
import LogoSherpa from '../../Icon/icons/LogoSherpa/index'
import LogoSherpa2025 from '../../Icon/icons/LogoSherpa2025/index'
import Logout from '../../Icon/icons/Logout/index'
import MailRu from '../../Icon/icons/MailRu/index'
import Market from '../../Icon/icons/Market/index'
import Marketplace from '../../Icon/icons/Marketplace/index'
import Meditation from '../../Icon/icons/Meditation/index'
import Meditation2 from '../../Icon/icons/Meditation2/index'
import Menu from '../../Icon/icons/Menu/index'
import MessageTextSquare from '../../Icon/icons/MessageTextSquare/index'
import Metaphysics from '../../Icon/icons/Metaphysics/index'
import MicOffOutline from '../../Icon/icons/MicOffOutline/index'
import MicOnOutline from '../../Icon/icons/MicOnOutline/index'
import Mind from '../../Icon/icons/Mind/index'
import Minus from '../../Icon/icons/Minus/index'
import MinusSquared from '../../Icon/icons/MinusSquared/index'
import Mobile from '../../Icon/icons/Mobile/index'
import Movie from '../../Icon/icons/Movie/index'
import Next from '../../Icon/icons/Next/index'
import Odnoklassniki from '../../Icon/icons/Odnoklassniki/index'
import ParanormalUnexplained from '../../Icon/icons/ParanormalUnexplained/index'
import Pause from '../../Icon/icons/Pause/index'
import Pdf from '../../Icon/icons/Pdf/index'
import Pencil from '../../Icon/icons/Pencil/index'
import Phone from '../../Icon/icons/Phone/index'
import PictureInPicture from '../../Icon/icons/PictureInPicture/index'
import Pin from '../../Icon/icons/Pin/index'
import PinnedFilled from '../../Icon/icons/PinnedFilled/index'
import Play from '../../Icon/icons/Play/index'
import PlayOutline from '../../Icon/icons/PlayOutline/index'
import PlayTriangle from '../../Icon/icons/PlayTriangle/index'
import PlayPlaylist from '../../Icon/icons/PlayPlaylist/index'
import PlayPlaylistOutline from '../../Icon/icons/PlayPlaylistOutline/index'
import PlayPreview from '../../Icon/icons/PlayPreview/index'
import PlayPreviewOutline from '../../Icon/icons/PlayPreviewOutline/index'
import Playlist from '../../Icon/icons/Playlist/index'
import PlaylistEmpty from '../../Icon/icons/PlaylistEmpty/index'
import PlaylistOutline from '../../Icon/icons/PlaylistOutline/index'
import Plus from '../../Icon/icons/Plus/index'
import PlusSquared from '../../Icon/icons/PlusSquared/index'
import Prev from '../../Icon/icons/Prev/index'
import Preview from '../../Icon/icons/Preview/index'
import Print from '../../Icon/icons/Print/index'
import Recipes from '../../Icon/icons/Recipes/index'
import Reddit from '../../Icon/icons/Reddit/index'
import Refresh from '../../Icon/icons/Refresh/index'
import Replay from '../../Icon/icons/Replay/index'
import Reply from '../../Icon/icons/Reply/index'
import Rewind from '../../Icon/icons/Rewind/index'
import Rewind30 from '../../Icon/icons/Rewind30/index'
import Search from '../../Icon/icons/Search/index'
import SearchFile from '../../Icon/icons/SearchFile/index'
import SearchText from '../../Icon/icons/SearchText/index'
import SecretsCoverups from '../../Icon/icons/SecretsCoverups/index'
import Send from '../../Icon/icons/Send/index'
import Share from '../../Icon/icons/Share/index'
import ShareAndroid from '../../Icon/icons/ShareAndroid/index'
import ShareAndroidSolid from '../../Icon/icons/ShareAndroidSolid/index'
import ShareIos from '../../Icon/icons/ShareIos/index'
import SidePanel from '../../Icon/icons/SidePanel/index'
import SmartCreate from '../../Icon/icons/SmartCreate/index'
import SlideFirst from '../../Icon/icons/SlideFirst/index'
import SlideFirstOutline from '../../Icon/icons/SlideFirstOutline/index'
import SlideLast from '../../Icon/icons/SlideLast/index'
import SlideLastOutline from '../../Icon/icons/SlideLastOutline/index'
import SlideNext from '../../Icon/icons/SlideNext/index'
import SlidePrev from '../../Icon/icons/SlidePrev/index'
import Facebook from '../../Icon/icons/Facebook/index'
import SortAlphAsc from '../../Icon/icons/SortAlphAsc/index'
import SortAlphDesc from '../../Icon/icons/SortAlphDesc/index'
import SortAsc from '../../Icon/icons/SortAsc/index'
import SortDesc from '../../Icon/icons/SortDesc/index'
import SortNumAsc from '../../Icon/icons/SortNumAsc/index'
import SortNumDesc from '../../Icon/icons/SortNumDesc/index'
import SortTilesAsc from '../../Icon/icons/SortTilesAsc/index'
import SortTilesDesc from '../../Icon/icons/SortTilesDesc/index'
import SpeakerFull from '../../Icon/icons/SpeakerFull/index'
import SpeakerHalf from '../../Icon/icons/SpeakerHalf/index'
import SpeakerMin from '../../Icon/icons/SpeakerMin/index'
import SpeakerMute from '../../Icon/icons/SpeakerMute/index'
import SpiritualGrowth from '../../Icon/icons/SpiritualGrowth/index'
import Stack from '../../Icon/icons/Stack/index'
import StackedCards from '../../Icon/icons/StackedCards/index'
import Star from '../../Icon/icons/Star/index'
import StarSolid from '../../Icon/icons/StarSolid/index'
import Stones from '../../Icon/icons/Stones/index'
import Stop from '../../Icon/icons/Stop/index'
import Submit from '../../Icon/icons/Submit/index'
import SubmitArrow from '../../Icon/icons/SubmitArrow/index'
import Telegram from '../../Icon/icons/Telegram/index'
import ThumbDownOutline from '../../Icon/icons/ThumbDownOutline/index'
import ThumbDownSolid from '../../Icon/icons/ThumbDownSolid/index'
import ThumbUpOutline from '../../Icon/icons/ThumbUpOutline/index'
import ThumbUpSolid from '../../Icon/icons/ThumbUpSolid/index'
import ThumbsDown from '../../Icon/icons/ThumbsDown/index'
import ThumbsUp from '../../Icon/icons/ThumbsUp/index'
import TikTok from '../../Icon/icons/TikTok/index'
import Timer from '../../Icon/icons/Timer/index'
import Tv from '../../Icon/icons/Tv/index'
import Twitch from '../../Icon/icons/Twitch/index'
import Twitter from '../../Icon/icons/Twitter/index'
import Txt from '../../Icon/icons/Txt/index'
import Ufo from '../../Icon/icons/Ufo/index'
import Unpinned from '../../Icon/icons/Unpinned/index'
import UnpinnedSide from '../../Icon/icons/UnpinnedSide/index'
import User from '../../Icon/icons/User/index'
import UserCircled from '../../Icon/icons/UserCircled/index'
import Users from '../../Icon/icons/Users/index'
import VK from '../../Icon/icons/VK/index'
import Voice from '../../Icon/icons/Voice/index'
import VoiceMode from '../../Icon/icons/VoiceMode/index'
import WhatsApp from '../../Icon/icons/WhatsApp/index'
import WindowNew from '../../Icon/icons/WindowNew/index'
import X from '../../Icon/icons/X/index'
import XCircled from '../../Icon/icons/XCircled/index'
import XSocial from '../../Icon/icons/XSocial/index'
import Yandex from '../../Icon/icons/Yandex/index'
import YandexEng from '../../Icon/icons/YandexEng/index'
import Yoga from '../../Icon/icons/Yoga/index'
import YouTube from '../../Icon/icons/YouTube/index'

// Existing SVG React component icons
const icons = [
  { name: 'AddPlaylistOutline', component: AddPlaylistOutline },
  { name: 'AirplayOutline', component: AirplayOutline },
  { name: 'All', component: All },
  { name: 'AltHealing', component: AltHealing },
  { name: 'Android', component: Android },
  { name: 'ArchetypeAlchemist', component: ArchetypeAlchemist },
  { name: 'ArchetypeExplorer', component: ArchetypeExplorer },
  { name: 'ArchetypeGuardian', component: ArchetypeGuardian },
  { name: 'ArchetypeHealer', component: ArchetypeHealer },
  { name: 'ArchetypeMystic', component: ArchetypeMystic },
  { name: 'ArchetypeObserver', component: ArchetypeObserver },
  { name: 'ArchetypeRebel', component: ArchetypeRebel },
  { name: 'ArchetypeSeeker', component: ArchetypeSeeker },
  { name: 'ArchetypeVisionary', component: ArchetypeVisionary },
  { name: 'Archive', component: Archive },
  { name: 'ArrowBottomRight', component: ArrowBottomRight },
  { name: 'ArrowDown', component: ArrowDown },
  { name: 'ArrowLeft', component: ArrowLeft },
  { name: 'ArrowRight', component: ArrowRight },
  { name: 'ArrowTopRight', component: ArrowTopRight },
  { name: 'ArrowUp', component: ArrowUp },
  { name: 'Bell', component: Bell },
  { name: 'BellCancel', component: BellCancel },
  { name: 'BellOff', component: BellOff },
  { name: 'BellSolid', component: BellSolid },
  { name: 'Book', component: Book },
  { name: 'Bookmark', component: Bookmark },
  { name: 'Calendar', component: Calendar },
  { name: 'Camera', component: Camera },
  { name: 'CaretDown', component: CaretDown },
  { name: 'CaretDownOutline', component: CaretDownOutline },
  { name: 'CaretLeft', component: CaretLeft },
  { name: 'CaretLeftOutline', component: CaretLeftOutline },
  { name: 'CaretRight', component: CaretRight },
  { name: 'CaretRightOutline', component: CaretRightOutline },
  { name: 'CaretUp', component: CaretUp },
  { name: 'CaretUpOutline', component: CaretUpOutline },
  { name: 'Cart', component: Cart },
  { name: 'CastOutline', component: CastOutline },
  { name: 'Certificate', component: Certificate },
  { name: 'Chart', component: Chart },
  { name: 'ChatNew', component: ChatNew },
  { name: 'Check', component: Check },
  { name: 'CheckSquared', component: CheckSquared },
  { name: 'ChevronDown', component: ChevronDown },
  { name: 'ChevronLeft', component: ChevronLeft },
  { name: 'ChevronRight', component: ChevronRight },
  { name: 'ChevronUp', component: ChevronUp },
  { name: 'CircularAdd', component: CircularAdd },
  { name: 'Clock', component: Clock },
  { name: 'ClockSolid', component: ClockSolid },
  { name: 'Close', component: Close },
  { name: 'ClosedCaptions', component: ClosedCaptions },
  { name: 'Comment', component: Comment },
  { name: 'CommentAdd', component: CommentAdd },
  { name: 'CommentSolid', component: CommentSolid },
  { name: 'ControlsOutline', component: ControlsOutline },
  { name: 'ConvoNew', component: ConvoNew },
  { name: 'Copy', component: Copy },
  { name: 'Courses', component: Courses },
  { name: 'CrystalBall', component: CrystalBall },
  { name: 'Crystals', component: Crystals },
  { name: 'Dashboard', component: Dashboard },
  { name: 'Delete', component: Delete },
  { name: 'Discord', component: Discord },
  { name: 'Document', component: Document },
  { name: 'DocumentNew', component: DocumentNew },
  { name: 'Dot', component: Dot },
  { name: 'Download', component: Download },
  { name: 'Edit', component: Edit },
  { name: 'EllipsisHorizontal', component: EllipsisHorizontal },
  { name: 'EllipsisVertical', component: EllipsisVertical },
  { name: 'Email', component: Email },
  { name: 'EventsPlus', component: EventsPlus },
  { name: 'Eye', component: Eye },
  { name: 'EyeHide', component: EyeHide },
  { name: 'EyeHideSolid', component: EyeHideSolid },
  { name: 'EyeOfHorus', component: EyeOfHorus },
  { name: 'EyeShow', component: EyeShow },
  { name: 'EyeShowSolid', component: EyeShowSolid },
  { name: 'Facebook', component: Facebook },
  { name: 'FastForward', component: FastForward },
  { name: 'FastForward10', component: FastForward10 },
  { name: 'File', component: File },
  { name: 'FilePdf', component: FilePdf },
  { name: 'Film', component: Film },
  { name: 'Filter', component: Filter },
  { name: 'FilterOff', component: FilterOff },
  { name: 'Fire', component: Fire },
  { name: 'Flag', component: Flag },
  { name: 'Fullscreen', component: Fullscreen },
  { name: 'FullscreenOff', component: FullscreenOff },
  { name: 'FullscreenOn', component: FullscreenOn },
  { name: 'GearOutline', component: GearOutline },
  { name: 'GearSolid', component: GearSolid },
  { name: 'Gift', component: Gift },
  { name: 'Globe', component: Globe },
  { name: 'GlobeArrow', component: GlobeArrow },
  { name: 'Google', component: Google },
  { name: 'Graph', component: Graph },
  { name: 'Hamsa', component: Hamsa },
  { name: 'HeadphonesOutline', component: HeadphonesOutline },
  { name: 'Heart', component: Heart },
  { name: 'HeartFill', component: HeartFill },
  { name: 'HeartOff', component: HeartOff },
  { name: 'History', component: History },
  { name: 'Home', component: Home },
  { name: 'IOS', component: IOS },
  { name: 'InfoCircled', component: InfoCircled },
  { name: 'InspiringDocs', component: InspiringDocs },
  { name: 'Instagram', component: Instagram },
  { name: 'Laptop', component: Laptop },
  { name: 'LearnerLevelAdvanced', component: LearnerLevelAdvanced },
  { name: 'LearnerLevelBeginner', component: LearnerLevelBeginner },
  { name: 'LearnerLevelIntermediate', component: LearnerLevelIntermediate },
  { name: 'LightHouse', component: LightHouse },
  { name: 'Link', component: Link },
  { name: 'LinkedIn', component: LinkedIn },
  { name: 'Location', component: Location },
  { name: 'Locked', component: Locked },
  { name: 'Login', component: Login },
  { name: 'LogoArchitect', component: LogoArchitect },
  { name: 'LogoSage', component: LogoSage },
  { name: 'LogoSherpa', component: LogoSherpa },
  { name: 'LogoSherpa2025', component: LogoSherpa2025 },
  { name: 'Logout', component: Logout },
  { name: 'MailRu', component: MailRu },
  { name: 'Market', component: Market },
  { name: 'Marketplace', component: Marketplace },
  { name: 'Meditation', component: Meditation },
  { name: 'Meditation2', component: Meditation2 },
  { name: 'Menu', component: Menu },
  { name: 'MessageTextSquare', component: MessageTextSquare },
  { name: 'Metaphysics', component: Metaphysics },
  { name: 'MicOffOutline', component: MicOffOutline },
  { name: 'MicOnOutline', component: MicOnOutline },
  { name: 'Mind', component: Mind },
  { name: 'Minus', component: Minus },
  { name: 'MinusSquared', component: MinusSquared },
  { name: 'Mobile', component: Mobile },
  { name: 'Movie', component: Movie },
  { name: 'Next', component: Next },
  { name: 'Odnoklassniki', component: Odnoklassniki },
  { name: 'ParanormalUnexplained', component: ParanormalUnexplained },
  { name: 'Pause', component: Pause },
  { name: 'Pdf', component: Pdf },
  { name: 'Pencil', component: Pencil },
  { name: 'Phone', component: Phone },
  { name: 'PictureInPicture', component: PictureInPicture },
  { name: 'Pin', component: Pin },
  { name: 'PinnedFilled', component: PinnedFilled },
  { name: 'Play', component: Play },
  { name: 'PlayOutline', component: PlayOutline },
  { name: 'PlayTriangle', component: PlayTriangle },
  { name: 'PlayPlaylist', component: PlayPlaylist },
  { name: 'PlayPlaylistOutline', component: PlayPlaylistOutline },
  { name: 'PlayPreview', component: PlayPreview },
  { name: 'PlayPreviewOutline', component: PlayPreviewOutline },
  { name: 'Playlist', component: Playlist },
  { name: 'PlaylistEmpty', component: PlaylistEmpty },
  { name: 'PlaylistOutline', component: PlaylistOutline },
  { name: 'Plus', component: Plus },
  { name: 'PlusSquared', component: PlusSquared },
  { name: 'Prev', component: Prev },
  { name: 'Preview', component: Preview },
  { name: 'Print', component: Print },
  { name: 'Recipes', component: Recipes },
  { name: 'Reddit', component: Reddit },
  { name: 'Refresh', component: Refresh },
  { name: 'Replay', component: Replay },
  { name: 'Reply', component: Reply },
  { name: 'Rewind', component: Rewind },
  { name: 'Rewind30', component: Rewind30 },
  { name: 'Search', component: Search },
  { name: 'SearchFile', component: SearchFile },
  { name: 'SearchText', component: SearchText },
  { name: 'SecretsCoverups', component: SecretsCoverups },
  { name: 'Send', component: Send },
  { name: 'Share', component: Share },
  { name: 'ShareAndroid', component: ShareAndroid },
  { name: 'ShareAndroidSolid', component: ShareAndroidSolid },
  { name: 'ShareIos', component: ShareIos },
  { name: 'SidePanel', component: SidePanel },
  { name: 'SlideFirst', component: SlideFirst },
  { name: 'SlideFirstOutline', component: SlideFirstOutline },
  { name: 'SlideLast', component: SlideLast },
  { name: 'SlideLastOutline', component: SlideLastOutline },
  { name: 'SlideNext', component: SlideNext },
  { name: 'SlidePrev', component: SlidePrev },
  { name: 'SmartCreate', component: SmartCreate },
  { name: 'SortAlphAsc', component: SortAlphAsc },
  { name: 'SortAlphDesc', component: SortAlphDesc },
  { name: 'SortAsc', component: SortAsc },
  { name: 'SortDesc', component: SortDesc },
  { name: 'SortNumAsc', component: SortNumAsc },
  { name: 'SortNumDesc', component: SortNumDesc },
  { name: 'SortTilesAsc', component: SortTilesAsc },
  { name: 'SortTilesDesc', component: SortTilesDesc },
  { name: 'SpeakerFull', component: SpeakerFull },
  { name: 'SpeakerHalf', component: SpeakerHalf },
  { name: 'SpeakerMin', component: SpeakerMin },
  { name: 'SpeakerMute', component: SpeakerMute },
  { name: 'SpiritualGrowth', component: SpiritualGrowth },
  { name: 'Stack', component: Stack },
  { name: 'StackedCards', component: StackedCards },
  { name: 'Star', component: Star },
  { name: 'StarSolid', component: StarSolid },
  { name: 'Stones', component: Stones },
  { name: 'Stop', component: Stop },
  { name: 'Submit', component: Submit },
  { name: 'SubmitArrow', component: SubmitArrow },
  { name: 'Telegram', component: Telegram },
  { name: 'ThumbDownOutline', component: ThumbDownOutline },
  { name: 'ThumbDownSolid', component: ThumbDownSolid },
  { name: 'ThumbUpOutline', component: ThumbUpOutline },
  { name: 'ThumbUpSolid', component: ThumbUpSolid },
  { name: 'ThumbsDown', component: ThumbsDown },
  { name: 'ThumbsUp', component: ThumbsUp },
  { name: 'TikTok', component: TikTok },
  { name: 'Timer', component: Timer },
  { name: 'Tv', component: Tv },
  { name: 'Twitch', component: Twitch },
  { name: 'Twitter', component: Twitter },
  { name: 'Txt', component: Txt },
  { name: 'Ufo', component: Ufo },
  { name: 'Unpinned', component: Unpinned },
  { name: 'UnpinnedSide', component: UnpinnedSide },
  { name: 'User', component: User },
  { name: 'UserCircled', component: UserCircled },
  { name: 'Users', component: Users },
  { name: 'VK', component: VK },
  { name: 'Voice', component: Voice },
  { name: 'VoiceMode', component: VoiceMode },
  { name: 'WhatsApp', component: WhatsApp },
  { name: 'WindowNew', component: WindowNew },
  { name: 'X', component: X },
  { name: 'XCircled', component: XCircled },
  { name: 'XSocial', component: XSocial },
  { name: 'Yandex', component: Yandex },
  { name: 'YandexEng', component: YandexEng },
  { name: 'Yoga', component: Yoga },
  { name: 'YouTube', component: YouTube },
]

const IconSvgDemo = () => (
  <div className="icon-svg-demo">
    <Tabs>
      <Tab label="SVG Icons">
        <article className="icon-svg-demo">
          <ul className="icon-svg-demo__list">
            {icons.map(({ name, component: IconComponent }) => (
              <li key={name} className="icon-svg-demo__item">
                <div className="icon-svg-demo__item-icon">
                  <IconComponent />
                </div>
                <div className="icon-svg-demo__item-label">
                  {name}
                </div>
              </li>
            ))}
          </ul>
        </article>
      </Tab>
      <Tab label="More Info">
        <article className="icon-svg-demo icon-svg-demo__inner icon-svg-demo__more-info">
          <H5>How to add new icons</H5>
          <ol>
            <li>
              Add the .svg file to the lib/theme/web-app/svg folder.
            </li>
            <li>
              Add the new icon to the lib/components/Icon/icons folder.
            </li>
            <li>
              Add the new icon to the lib/theme/web-app/mixins/_icons.scss file.
              If you are updating an existing icon and you use the same file name,
               add a cache busting string to the url in the mixin.
            </li>
          </ol>
        </article>
      </Tab>
    </Tabs>
  </div>
)

export default IconSvgDemo
